import React, { Component } from "react";
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {toastr} from "react-redux-toastr";
import { Loader } from "../Common/Loader";
import {
    renderTextInputField,
    renderEmailInputField,
    renderSelectField
} from '../Layout/FormInputs'
import {langs} from '../../config/localization';
import Transition from 'react-transition-group/Transition';
import {setContactUsData} from "../../actions/UserAction";
import {required, maxLength30, maxLength100} from '../../validation';
import {eventTracking} from "../../actions/UserAction";
import {focusOnError} from "../../utils";

class ContactUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false
        };
    }

    /**
     * Set contactus data
     * @param values
     */
    onSubmit(values){
        this.setState({showLoader : true});

        /* Action tracking */
        let originRoute = document.referrer;
        let destinationRoute = window.location.href;
        let date = new Date();
        let postData = {type: 'ContactSelected', originRoute: originRoute, destinationRoute: destinationRoute, timestamp: date};
        this.props.eventTracking(postData);
        /* Action tracking */

        values.name = String.prototype.trim.call(values.name);
        values.email = String.prototype.trim.call(values.email);
        values.comment = String.prototype.trim.call(values.comment);
        //Call the set signup data action
        this.props.setContactUsData(values, (response)=>{
            this.setState({showLoader : false});
            if(response.status === 200){
                toastr.success(langs.success, langs.messages.contact_successfully);
                setTimeout(function(){ window.location.reload(); }, 1000);
            }else {
                toastr.error(langs.error, langs.messages.default_error);
            }
        });
    }

    render() {
        const {handleSubmit} = this.props;
        if(!this.state.showLoader) {
            return (
                <div className="row">
                    <div className="medium-12 columns">
                        <div className="section-contact">
                            <div className="row">
                              <form noValidate className="form border-right" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                  <div className="medium-7 columns ">
                                      <h2>Contact</h2>
                                      <div className="row">
                                          <div className="medium-6 columns">
                                              <div className="form-group">
                                                {/* <label>Name*</label> */}
                                                  <Field
                                                      name="name"
                                                      component={renderTextInputField}
                                                      maxLength="30"
                                                      placeholder="Name*"
                                                  />
                                              </div>
                                          </div>
                                          <div className="medium-6 columns">
                                              <div className="form-group">
                                                {/* <label></label> */}
                                                  <Field
                                                      name="email"
                                                      maxLength="100"
                                                      component={renderEmailInputField}
                                                      placeholder="Email*"
                                                  />
                                              </div>
                                          </div>
                                      </div>
                                      <div className="row">
                                          <div className="medium-12 columns">
                                              <div className="form-group">
                                                {/* <label>Message*</label> */}
                                                  <Field
                                                      name="comment"
                                                      component={renderTextInputField}
                                                      placeholder="Message*"
                                                  />
                                              </div>
                                          </div>
                                      </div>
                                      <div className="row">
                                          <div className="medium-12 columns">
                                              <div className="form-group">
                                                  <button type="submit" className="btn-primary primary-gradient-bg">
                                                      <span>SEND</span>
                                                  </button>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </form>
                            <div className="medium-5 columns">
                                <div className="section-address">
                                    <p><span className="address-icon"><img src="/assets/images/eathdeck/address_icon.png" /></span><span>PO Box 4001, Los Altos, CA 94024 USA</span></p>
                                    <p><span className="address-icon"><img src="/assets/images/eathdeck/phone.png" /></span><span>001-650-292-0751</span></p>
                                </div>
                                {/*<div className="connect-us">
                                    <h4>Connect with us</h4>
                                    <ul>
                                        <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
                                        <li><a href="#"><i className="fa fa-facebook"></i></a></li>
                                        <li><a href="#"><i className="fa fa-twitter"></i></a></li>
                                        <li><a href="#"><i className="fa fa-google-plus"></i></a></li>
                                    </ul>
                                </div>*/}
                            </div>
                            </div>
                            {/*<p className="copyright">Copyright @ {(new Date().getFullYear() - 1)} - {(new Date().getFullYear())} earthDECKS</p>*/}
                        </div>
                    </div>
                </div>
            )
        } else {
            return <Loader loaderContent='form-submission'/>
        }
        }
}

//export default About;

/**
 * Form validations
 * @param values
 * @returns {{}}
 */
function validate(values){
    let errors = {};

    if(!values.name){
        errors.name = langs.validation_messages.fullname_required;
    }

    if (values.name && values.name.length > 30){
        errors.name = langs.validation_messages.fullname_pattern;
    }

    if(!values.email){
        errors.email = langs.validation_messages.email_required;
    }

    if(values.email && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(values.email) == false){
        errors.email = langs.validation_messages.email_pattern;
    }

    if(!values.comment){
        errors.comment = langs.validation_messages.comment_required;
    }

    return errors;
}

export default reduxForm({
    validate,
    form: 'ContactUs',
    onSubmitFail: (errors) => {
        focusOnError(errors)
    }
})(
    connect(null, {setContactUsData, eventTracking})(ContactUs)
);



// WEBPACK FOOTER //
// ./components/Common/ContactUs.js